<script>
    import ScreenContainer from "./screenContainer.svelte";
    import url from '../../stores/url';
    import * as storeHelpers from '../../stores/helpers';

    export let notes = [];
    export let items = [];
    export let updateNoteContent;
    
    export let navigateToNote;

    let linkedContent = [];
    let innerWidth;

    $: urlHash = $url.hash?.slice(1);
    // $: urlPathname = $url.pathname;

    // if urlPathname is the same as any of the content.uuids... then we're linked within the same note.
    // mark it as such so we can stay within the same browser tab
    
    const getTitle = (content) => {
        if (content.title) return content.title;
        return getHeader(storeHelpers.stringifyNoteContent(content.content))
    }

    function getHeader(text) {
        let headerRule = /\#(.*?)\n/;
        let match = headerRule.exec(text);
        if (!match) {
            headerRule = /\#(.*?)\\n/;
            match = headerRule.exec(text);
            if (!match) return ''
        }
        return match[1].trim() + (urlHash ? ` · ${urlHash}` : '');
    }

    $: display = (notes && notes.length) || (items && items.length)

    $: {
        linkedContent = [...notes, ...items]
            .map(content => {
                return {
                    date: content.createdAt || content.addedAt,
                    title: getTitle(content),
                    link: content.link || null,
                    noteLink: content.uuid && `/notes/${content.uuid}${urlHash ? '#' + urlHash : ''}`,
                    noteUid: content.uuid,
                    userID: content.userID,
                    tags: content.tags ?? [],
                    textBody: content.textBody,
                    id: content.id,
                }
            })
            .sort((a, b) => a.date - b.date)
    }
</script>

<svelte:window bind:innerWidth={innerWidth}/>

{#if display}
    <main>
        <ScreenContainer
            linkedContent={linkedContent}
            innerWidth={innerWidth}
            updateNoteContent={updateNoteContent}
            navigateToNote={navigateToNote}
        />
    </main>
{/if}

<style>

</style>